import type { VideoResolution } from '@/lib/constants'

export function normalizeVideoResolution(value: unknown): VideoResolution {
  if (typeof value !== 'string') return '768P'

  switch (value.toLowerCase()) {
    case '2k':
    case '1080p':
      return '2K'
    case '768p':
    case '720p':
    case '480p':
    default:
      return '768P'
  }
}

export function normalizeVideoDuration(value: unknown): number {
  if (typeof value !== 'number' || !Number.isInteger(value)) return 5
  return Math.min(15, Math.max(4, value))
}
